import { BigmlAnswersDTO, IBigmlAnswersDTO } from "./BigmlAnswers.DTO";
import { BigmlAppsDTO, IBigmlAppsDTO } from "./BigmlApps.DTO";
import { Nilable } from "@shared/utils";

export interface IBigmlEnvioDTO {
    project_id: Nilable<number>;
    project_name: Nilable<string>;
    amount_cases: Nilable<number>;
    objective_combo: Nilable<number>;
    series: Nilable<number[]>;
    train_regions: Nilable<number[]>;
    predict_regions: Nilable<number[]>;
    message: Nilable<string>;
    total_train_users: Nilable<number>;
    total_predict_users: Nilable<number>;
    gender: Nilable<string[]>;
    age_range: Nilable<string[]>;
    nse: Nilable<string[]>;
    balance_data: Nilable<boolean>;
    train_answers: Nilable<IBigmlAnswersDTO>;
    train_apps: Nilable<IBigmlAppsDTO>;
    predict_answers: Nilable<IBigmlAnswersDTO>;
    predict_apps: Nilable<IBigmlAppsDTO>;
    questions_ids: Nilable<number[]>;
    apps_names: Nilable<string[]>;
    train_multiple_choice_questions: Nilable<number[]>;
    predict_multiple_choice_questions: Nilable<number[]>;
    train_users_removed: Nilable<number>;
    predict_users_removed: Nilable<number>;
    train_mc_questions: Nilable<number[]>;
    predict_mc_questions: Nilable<number[]>;
    train_questions: Nilable<number[]>;
    train_users: Nilable<number[]>;
    train_dataset: Nilable<any[]>;
    train_dataset_cols: Nilable<string[]>;
    predict_questions: Nilable<number[]>;
    predict_users: Nilable<number[]>;
    predict_dataset: Nilable<any[]>;
    predict_dataset_cols: Nilable<string[]>;
    prioritize_predict: Nilable<boolean>;
}

export class BigmlEnvioDTO {
    public projectId = 0;
    public projectName = "";
    public amountCases = 0;
    public objectiveCombo = 0;
    public series: number[] = [];
    public trainRegions: number[] = [];
    public predictRegions: number[] = [];
    public message = "";
    public totalTrainUsers = 0;
    public totalPredictUsers = 0;
    public gender: string[] = [];
    public ageRange: string[] = [];
    public nse: string[] = [];
    public balanceData = false;
    public trainAnswers: Nilable<BigmlAnswersDTO> = null;
    public trainApps: Nilable<BigmlAppsDTO> = null;
    public predictAnswers: Nilable<BigmlAnswersDTO> = null;
    public predictApps: Nilable<BigmlAppsDTO> = null;
    public questionsIds: number[] = [];
    public appsNames: string[] = [];
    public trainMultipleChoiceQuestions: number[] = [];
    public predictMultipleChoiceQuestions: number[] = [];
    public trainUsersRemoved = 0;
    public predictUsersRemoved = 0;
    public trainMCQuestions: number[] = [];
    public predictMCQuestions: number[] = [];
    public trainQuestions: number[] = [];
    public trainUsers: number[] = [];
    public trainDataset: Map<string, string>[] = [];
    public trainDatasetCols: string[] = [];
    public predictQuestions: number[] = [];
    public predictUsers: number[] = [];
    public predictDataset: Map<string, string>[] = [];
    public predictDatasetCols: string[] = [];
    public prioritizePredict = false;

    constructor(json: Nilable<Partial<IBigmlEnvioDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IBigmlEnvioDTO>) {
        if (json.project_id != null) {
            this.projectId = json.project_id;
        }
        if (json.project_name != null) {
            this.projectName = json.project_name;
        }
        if (json.amount_cases != null) {
            this.amountCases = json.amount_cases;
        }
        if (json.objective_combo != null) {
            this.objectiveCombo = json.objective_combo;
        }
        if (json.series != null) {
            this.series = json.series;
        }
        if (json.message != null) {
            this.message = json.message;
        }
        if (json.total_train_users != null) {
            this.totalTrainUsers = json.total_train_users;
        }
        if (json.total_predict_users != null) {
            this.totalPredictUsers = json.total_predict_users;
        }
        if (json.gender != null) {
            this.gender = json.gender;
        }
        if (json.age_range != null) {
            this.ageRange = json.age_range;
        }
        if (json.balance_data != null) {
            this.balanceData = json.balance_data;
        }
        this.trainAnswers = new BigmlAnswersDTO(json.train_answers);
        this.trainApps = new BigmlAppsDTO(json.train_apps);
        this.predictAnswers = new BigmlAnswersDTO(json.predict_answers);
        this.predictApps = new BigmlAppsDTO(json.predict_apps);
        if (json.questions_ids != null) {
            this.questionsIds = json.questions_ids;
        }
        if (json.apps_names != null) {
            this.appsNames = json.apps_names;
        }
        if (json.train_multiple_choice_questions != null) {
            this.trainMultipleChoiceQuestions = json.train_multiple_choice_questions;
        }
        if (json.predict_multiple_choice_questions != null) {
            this.predictMultipleChoiceQuestions = json.predict_multiple_choice_questions;
        }
        if (json.train_users_removed != null) {
            this.trainUsersRemoved = json.train_users_removed;
        }
        if (json.predict_users_removed != null) {
            this.predictUsersRemoved = json.predict_users_removed;
        }
        if (json.train_mc_questions != null) {
            this.trainMCQuestions = json.train_mc_questions;
        }
        if (json.predict_mc_questions) {
            this.predictMCQuestions = json.predict_mc_questions;
        }
        if (json.train_questions != null) {
            this.trainQuestions = json.train_questions;
        }
        if (json.train_users != null) {
            this.trainUsers = json.train_users;
        }
        if (json.train_dataset != null) {
            this.trainDataset = json.train_dataset;
        }
        if (json.predict_questions != null) {
            this.predictQuestions = json.predict_questions;
        }
        if (json.predict_users != null) {
            this.predictUsers = json.predict_users;
        }
        if (json.predict_dataset != null) {
            this.predictDataset = json.predict_dataset;
        }
    }

    public toJSON(): IBigmlEnvioDTO {
        return {
            project_id: this.projectId,
            project_name: this.projectName,
            amount_cases: this.amountCases,
            objective_combo: this.objectiveCombo,
            series: this.series,
            train_regions: this.trainRegions,
            predict_regions: this.predictRegions,
            message: this.message,
            total_train_users: this.totalTrainUsers,
            total_predict_users: this.totalPredictUsers,
            gender: this.gender,
            age_range: this.ageRange,
            nse: this.nse,
            balance_data: this.balanceData,
            train_answers: this.trainAnswers?.toJSON() ?? null,
            train_apps: this.trainApps?.toJSON() ?? null,
            predict_answers: this.predictAnswers?.toJSON() ?? null,
            predict_apps: this.predictApps?.toJSON() ?? null,
            questions_ids: this.questionsIds,
            apps_names: this.appsNames,
            train_multiple_choice_questions: this.trainMultipleChoiceQuestions,
            predict_multiple_choice_questions: this.predictMultipleChoiceQuestions,
            train_users_removed: this.trainUsersRemoved,
            predict_users_removed: this.predictUsersRemoved,
            train_mc_questions: this.trainMCQuestions,
            predict_mc_questions: this.predictMCQuestions,
            train_questions: this.trainQuestions,
            train_users: this.trainUsers,
            train_dataset: this.trainDataset,
            train_dataset_cols: this.trainDatasetCols,
            predict_questions: this.predictQuestions,
            predict_users: this.predictUsers,
            predict_dataset: this.predictDataset,
            predict_dataset_cols: this.predictDatasetCols,
            prioritize_predict: this.prioritizePredict
        };
    }
}
